import { initializeApp } from 'firebase/app';
import { getDatabase } from 'firebase/database';
import { getAnalytics, logEvent } from 'firebase/analytics';

const firebaseConfig = {
    apiKey: "AIzaSyDtHBSawmjmXXsFUZlmH4hf3mhcNovQtVg",
    authDomain: "chain-game-dd7c9.firebaseapp.com",
    databaseURL: "https://chain-game-dd7c9-default-rtdb.firebaseio.com",
    projectId: "chain-game-dd7c9",
    storageBucket: "chain-game-dd7c9.appspot.com",
    messagingSenderId: "947075914331",
    appId: "1:947075914331:web:100eff632cc17ca15dfd7e",
    measurementId: "G-DYDK5KNQS7"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
const database = getDatabase(app);
const analytics = getAnalytics(app);

// Track page views
export const trackPageView = (pageName) => {
  logEvent(analytics, 'page_view', {
    page_title: pageName,
    page_location: window.location.href,
    page_path: window.location.pathname
  });
};

// Track game events
export const trackGameEvent = (eventName, params = {}) => {
  logEvent(analytics, eventName, params);
};

console.log("Firebase initialized successfully");

export { database, analytics }; 